var map = {
	"./fakeData.js": 8796,
	"./fonts/poppins.woff": 1056,
	"./fonts/poppins.woff2": 1611,
	"./icons/10am.svg": 8999,
	"./icons/3pm.svg": 8585,
	"./icons/7pm.svg": 6762,
	"./icons/avatar-default.svg": 7974,
	"./icons/before-sleep.svg": 6662,
	"./icons/breakfast.svg": 8564,
	"./icons/confirm-logo-title.svg": 8096,
	"./icons/dashboard-doctor.svg": 3646,
	"./icons/dinner.svg": 2215,
	"./icons/icon-done.svg": 1105,
	"./icons/info-icon-error.svg": 9276,
	"./icons/info-icon.svg": 3309,
	"./icons/lunch.svg": 3838,
	"./icons/purse.svg": 5638,
	"./icons/refresh.svg": 9525,
	"./icons/tablet-green.svg": 8771,
	"./icons/tablet.svg": 3233,
	"./icons/trial.svg": 7356,
	"./icons/upon-arising.svg": 6391,
	"./icons/vitamins.png": 6646,
	"./images/back-dp.jpg": 7823,
	"./images/logo.svg": 2835,
	"./images/logo_drawer.svg": 8527,
	"./images/logo_drawer_short.svg": 1753,
	"./images/slider/slide1.jpeg": 6304,
	"./images/slider/slide2.jpeg": 8457,
	"./images/slider/slide3.jpeg": 4803,
	"./images/success.svg": 1185,
	"./images/temp-icon.jpg": 583,
	"./sounds/quick-entry/chpok.mp3": 1469,
	"./sounds/quick-entry/done.mp3": 2845,
	"./sounds/quick-entry/error.mp3": 6659,
	"./sounds/quick-entry/guu.mp3": 6667,
	"./sounds/quick-entry/qwa-qwa.mp3": 8886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6041;